import { axios } from '@/api/request'

/**
 * api接口列表
 */
const api = {
  login:'/qywxLogin/',
  getsucais:'/teams/sucaifile/'

}

export function login (data) {
  return axios({
    url: api.login,
    method: 'post',
    data
  })
}

export function getsucais (params) {
  return axios({
    url: api.getsucais,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/sucaiview/sucailist/api.js